/* eslint-disable max-len */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector ,useDispatch} from 'react-redux'
import AnimatedList from '../../../../../../components/Animation/AnimatedList'
import moment from 'moment'
import { convertEpochToDateFormat } from '../../../../../../CommonMethods/DateConversion'

const TableBody=({
    tableData,
    indexNum,
})=>{
    const dateformat=useSelector(state=>state?.systemConfigData?.globalVariables?.date_format)
    const fieldTOUpdate={
        'user_name':'Username',
        'field':'Fields',
        'timestamp':'Date and Time',
        'old_value':'Old Value',
        'new_value':'New Value',
        'action':'Action Performed',
        'comments':'Comments',
        'user_id':'Organization User ID',
        'sub_divisions.id':'Sub Division ID',
        'sub_divisions.name':'Sub Division Name',
        'organization_id':'Organization ID'


    }

    const valuesToUpdate={
        'inactive':'Inactive',
        'active':'Active',
        'admin':'Admin',
        'user':'User'
    }

    const date=convertEpochToDateFormat(tableData?.timestamp,dateformat)
    // const date = dateformat?.includes('AM/PM')?moment(tableData?.timestamp).utcOffset('+5:30').format(`${dateformat.split(',')[0]} h:mm:ss A`):moment(tableData?.created_at).format(dateformat)
    return(
        <>
            <AnimatedList
                id={tableData.user_id}
                rowStatus={tableData.status}
                keyItem={indexNum}
                child={
                    <>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] rounded-tl-[2px] rounded-bl-[2px]">
                            {tableData?.user_name}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">
                            {date}
                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">{tableData?.action}</td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize">
                            {fieldTOUpdate[tableData?.field] &&
                                typeof fieldTOUpdate[tableData?.field] === 'string'
                                ? fieldTOUpdate[tableData?.field].replace(/[_.]/g, " ")
                                : (tableData?.field || '').toString().replace(/[_.]/g, " ")}

                        </td>
                        <td className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]">{tableData?.old_value==='' ? '-' : valuesToUpdate[tableData?.old_value]?valuesToUpdate[tableData?.old_value]:tableData?.old_value}</td>
                        <td className='px-[9px] py-2.5 text-sm text-start font-normal text-[#031624]'>{tableData?.new_value==='' ?'-':valuesToUpdate[tableData?.new_value]?valuesToUpdate[tableData?.new_value]:tableData?.new_value }</td>
                        <td maxLength={300} className="px-[9px] py-2.5 text-sm text-start font-normal text-[#031624] capitalize rounded-tl-sm rounded-bl-sm">{tableData?.comments===''?'-':tableData?.comments}</td>
                    </>
                    
                }/>
           
        </>
    )
}

export default TableBody